import React from 'react';

const ImageSliderItem = props => {
  const { inner } = props;

  return (
    <div className="slider-inner">
      {inner}
    </div>
  );
}

export default ImageSliderItem;



// WEBPACK FOOTER //
// ./src/components/common/image-slider/image-slider-item.jsx